import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  BackendService,
  HttpOptions,
  PaginatedResponseModel,
} from '@ipg/ngx-frontend-toolset';
import { Device } from '../../../models/devices.model';

@Injectable({
  providedIn: 'root',
})
export class ClientDevicesService {
  private readonly _backend = inject(BackendService);

  getAll(
    clientId: string,
    options?: HttpOptions
  ): Observable<PaginatedResponseModel<Device[]>> {
    return this._backend.get(`/clients/${clientId}/devices`, options);
  }
}
